module.exports = __webpack_public_path__ + "findzen-app-icon.c67792f8673b5f89c65a058ae30f659c.png";